/**
 * TtfMicrosoftCmapSubTable.ts class for EJ2-PDF
 */
var TtfMicrosoftCmapSubTable = /** @class */ (function () {
    function TtfMicrosoftCmapSubTable() {
    }
    return TtfMicrosoftCmapSubTable;
}());
export { TtfMicrosoftCmapSubTable };
